var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',{staticClass:"p-datatable-tbody"},_vm._l((_vm.rows),function(n){return _c('tr',{key:n},_vm._l((_vm.columns),function(col,i){return _c('td',{key:col.columnKey||col.field||i},[_c('DTColumnSlot',{attrs:{"column":col,"index":i,"type":"loading"}})],1)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }